import { Link } from 'react-router-dom'
import { Zap, Phone, Mail, MapPin, ArrowUpRight } from 'lucide-react'

const footerLinks = {
  services: [
    { label: '投建规划', path: '/services' },
    { label: '智能运维', path: '/services' },
    { label: '品牌运营', path: '/services' },
  ],
  company: [
    { label: '关于我们', path: '/about' },
    { label: '解决方案', path: '/solutions' },
    { label: '联系我们', path: '/contact' },
  ],
}

export default function Footer() {
  return (
    <footer className="bg-dark border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-3 group mb-6">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-neon-green to-neon-cyan flex items-center justify-center neon-glow group-hover:scale-110 transition-transform">
                <Zap className="w-5 h-5 text-dark" />
              </div>
              <div className="flex flex-col">
                <span className="text-white font-bold text-lg">ONEEC</span>
                <span className="text-white/50 text-xs">壹电利科技</span>
              </div>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              新能源汽车充电产业生态服务商<br />
              技术驱动 · 生态聚合 · 全域赋能
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 flex items-center">
              <span className="w-1 h-4 bg-neon-green rounded-full mr-2"></span>
              核心服务
            </h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-white/50 hover:text-neon-green transition-colors text-sm flex items-center group"
                  >
                    {link.label}
                    <ArrowUpRight className="w-3 h-3 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 flex items-center">
              <span className="w-1 h-4 bg-neon-green rounded-full mr-2"></span>
              关于公司
            </h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-white/50 hover:text-neon-green transition-colors text-sm flex items-center group"
                  >
                    {link.label}
                    <ArrowUpRight className="w-3 h-3 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 flex items-center">
              <span className="w-1 h-4 bg-neon-green rounded-full mr-2"></span>
              联系方式
            </h3>
            <ul className="space-y-4">
              <li>
                <a href="tel:17778002535" className="flex items-center space-x-3 text-white/50 hover:text-neon-green transition-colors group">
                  <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center group-hover:bg-neon-green/10 transition-colors">
                    <Phone className="w-4 h-4" />
                  </div>
                  <span className="text-sm">177-7800-2535</span>
                </a>
              </li>
              <li>
                <a href="mailto:market@oneec.cn" className="flex items-center space-x-3 text-white/50 hover:text-neon-green transition-colors group">
                  <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center group-hover:bg-neon-green/10 transition-colors">
                    <Mail className="w-4 h-4" />
                  </div>
                  <span className="text-sm">market@oneec.cn</span>
                </a>
              </li>
              <li>
                <div className="flex items-center space-x-3 text-white/50">
                  <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center">
                    <MapPin className="w-4 h-4" />
                  </div>
                  <span className="text-sm">北京市石景山区古城大街中海大厦</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/30 text-sm">
              © 2026 北京壹电利科技有限公司. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <span className="text-white/30 text-sm">京ICP备2024079506号</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
